import type { HeaderItem } from "@cm-websites/common";

export const HEADER_ITEMS: HeaderItem[] = [
  { label: "Murder Mystery Games", route: "/" },
  { label: "Order", route: "/#order" },
  {
    label: "Help & Support",
    children: [
      {
        label: "What is a Murder Mystery?",
        route: "/what-is-a-murder-mystery-party",
      },
      { label: "Rules and procedure", route: "/rules" },
      { label: "Download role descriptions", route: "/preparation" },
      { label: "Download lost materials", route: "/missing-materials" },
      { label: "Frequent questions", route: "/frequent-questions" },
      { label: "Contact", route: "/contact" },
    ],
  },
];
